import { faker } from '@faker-js/faker'

import { DailySlots } from '../../contracts/reservation/DailySlots'
import { asBuilder } from '../asBuilder'

export const getDailySlotsForChangeReservation = asBuilder<DailySlots>((): DailySlots => {
  return {
    slots: faker.helpers.multiple(
      () => ({
        id: faker.number.int(),
        thresholdCount: faker.number.int({ min: 0, max: 5 }),
        reservationCount: faker.number.int({ min: 0, max: 5 }),
        enable: faker.datatype.boolean(),
        isAvailable: faker.datatype.boolean(),
        startDateTimeUtc: faker.date.recent().toISOString(),
        endDateTimeUtc: faker.date.recent().toISOString(),
      }),
      { count: 7 },
    ),
  }
})

export const getDailySlotsForReservation = asBuilder<DailySlots>((): DailySlots => {
  return {
    slots: faker.helpers.multiple(
      () => ({
        id: faker.number.int(),
        thresholdCount: faker.number.int({ min: 0, max: 5 }),
        reservationCount: faker.number.int({ min: 0, max: 5 }),
        enable: faker.datatype.boolean(),
        isAvailable: faker.datatype.boolean(),
        startDateTimeUtc: faker.date.recent().toISOString(),
        endDateTimeUtc: faker.date.recent().toISOString(),
      }),
      { count: 7 },
    ),
  }
})
